// extracted by mini-css-extract-plugin
export var contact = "ServicePage-module--contact--rt2qD";
export var proudOfSubTitle = "ServicePage-module--proudOfSubTitle--2g6Hw";
export var swiperProgress = "ServicePage-module--swiperProgress--6TlM1";